import { useConfigurationSelector } from "../context/ConfigurationReduxContext";
import { getConfigurationNavigationPaths } from "../reducers/selectors";
/**
 * Returns of mapping of previous navigation
 * @category Hook
 */
export function useConfigurationNavigationState() {
    return useConfigurationSelector(getConfigurationNavigationPaths);
}
//# sourceMappingURL=useConfigurationNavigationState.js.map